module.exports ={
    overview: {
        on:'オンライン',
        off:'オフライン',
        unit:'',
        gateway:{
            title:'ゲートウェイ'
        },
        label:{
            title:'棚札'
        },
        labelUpdate:{
            title:'更新する',
            success: '成功する',
            fail: '失敗する'
        },
        labelBattery:{
            title:'バッテリー',
            normal:'普通',
            exception:'ローバッテリー'
        },
        operate:{
            title:'運営',
            updateData:'先週の棚札の更新',
            unitUpdateSuccess:'成功/時間を更新',
            unitUpdate:'更新/時間',
            updateSuccessRate:'成功率を更新',
            updateSuccess:'正常に更新されました',
            updateFail:'更新できませんでした',
            // xTime:['周一','周二','周三','周四','周五','周六','周日']
            xTime:['昨日の前日','昨日','今日']
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/overview.js